<!-- Phase 2 shell: left rail always visible (X-style); main shrinks with viewport; max-width 1280px cluster; &lt;1280px start-aligned; ≥1280px centered + semantic <main>.
     Same components and ViewChild refs (#mainContent, #sidebar, #sidebarContent). -->
<div class="ts-dashboard-shell">
    <div class="ts-dashboard-center-track">
        <div class="ts-dashboard-cluster g-0">
            <aside class="col-auto ts-rail-left left_sidebar ts-rail-column border-end d-flex flex-column px-0 align-items-stretch"
                   aria-label="Main navigation">
                <app-left-sidebar class="ts-sidebar-host"
                                  [Username]="Username"
                                  [UserID]="UserID"
                                  (postSubmitComplete)="getUserPostsDataNew(true)"
                                  (postContent)="updatePostContent($event)"
                                  (mediaUrlsChange)="updatePostMediaUrls($event)"
                                  (replyTypeChange)="updateReplyType($event)"
                                  (onSave)="savePost()">
                </app-left-sidebar>
            </aside>

            <main class="px-0 main_bar ts-main-feed-themed ts-dashboard-main" #mainContent role="main">
                <header class="ts-sticky-feed-header">
                    <div class="ts-feed-header-row">
                        <div class="ts-feed-tabs">
                            <button type="button"
                                    [class.ts-feed-tab-active]="feedTab === 'foryou'"
                                    (click)="setFeedTab('foryou')">
                                For You
                            </button>
                            <button type="button"
                                    [class.ts-feed-tab-active]="feedTab === 'following'"
                                    (click)="setFeedTab('following')">
                                Following
                            </button>
                        </div>
                    </div>
                </header>

                <section class="ts-composer-section border-bottom">
                    <div class="ts-composer-inner">
                        <div class="ts-composer-avatar user-avatar-container-top">
                            <img [src]="'api/content/logo?userID=' + UserID" (error)="onApiLogoError($event)" alt="">
                        </div>
                        <div class="ts-composer-body">
                            <app-post-submit [Username]="Username"
                                             [UserID]="UserID"
                                             [pageType]="'postSubmitModal'"
                                             [mediaUrls]="mediaUrls"
                                             [selectedReplyType]="selectedReplyType"
                                             (postContent)="updatePostContent($event)"
                                             (removeMedia)="removeMediaFromFooter($event)">
                            </app-post-submit>
                            <app-post-footer #footerComponent
                                             [Username]="Username"
                                             [UserID]="UserID"
                                             [hasPostText]="hasPostText"
                                             [pageType]="'Home'"
                                             (mediaUrlsChange)="updatePostMediaUrls($event)"
                                             (replyTypeChange)="updateReplyType($event)"
                                             (onSave)="savePost()">
                            </app-post-footer>
                        </div>
                    </div>
                </section>

                <div class="ts-feed-posts mt-4 pt-2">
                        <div *ngFor="let postData of UserPostsData; let i = index" #postElement>
                            <div [id]="'post' + ((currentPage - 1) * pageSize + i)"
                                 class="post-container"
                                 (click)="navigateToPost(postData.UserName, postData.TSID)">
                                <app-post-detail (postEditedOrDeleted)="getUserPostsDataNew(true)"
                                                 (reactionsUpdated)="onReactionsUpdated($event.postId, $event.reactions)"
                                                 [Username]="Username"
                                                 [UserID]="UserID"
                                                 [postData]="postData"
                                                 [pageType]="'dashboard'">
                                </app-post-detail>
                            </div>
                            <div *ngIf="isLoading">
                                Loading more posts...
                            </div>
                        </div>
                </div>
            </main>

            <div class="ts-dashboard-gutter ts-dashboard-gutter--end flex-shrink-0"
                 aria-hidden="true"></div>

            <aside class="col-auto ts-rail-right ts-rail-right--dashboard ts-rail-column right_side_bar d-flex flex-column px-0 align-items-stretch min-h-0"
                   aria-label="Search and suggestions"
                   #sidebar>
                <div class="sidebar-content" #sidebarContent>
                    <app-right-sidebar [Username]="Username"
                                       [UserID]="UserID">
                    </app-right-sidebar>
                </div>
            </aside>
        </div>
    </div>
</div>
